import Skeleton from '@mui/material/Skeleton';

export function TabsSkeleton() {
  return (
    <div
      style={{
        display: 'flex',
        gap: '1rem',
        padding: '0.5rem',
      }}
      className="qlf-skeleton"
      data-testid="skeleton"
      role="status"
    >
      <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: 1 }} />
    </div>
  );
}
